import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import {
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Tab,
  Tabs,
  AppBar,
  TextField,
  Box,
  Card
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import moment from 'moment';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import * as R from 'ramda';
import { ProviderContext, withSnackbar } from 'notistack';
import { ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import {
  SupplierProducer,
  Workflow,
  WorkflowSupplier,
  WorkflowSupplierProducerDiscount,
  WorkflowSupplierProducerDiscountFilters
} from '../../interfaces/Workflow';
import { IWorkflowService } from '../../services/Interfaces/IWorkflowService';
import { MUITranslations } from '../../helpers/MUITableTranslations';
import NumberFormat from 'react-number-format';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { OrganizationTypeCode } from '../../helpers/Constants';
import { Organization } from '../../interfaces/Organization';

interface WorkflowSupplierProducerDiscountState {
  newWorkflowSupplierProducerDiscount: WorkflowSupplierProducerDiscount;
  workflowSupplierProducerDiscountList: WorkflowSupplierProducerDiscount[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newWorkflowSupplierProducerDiscountId: number | null;
  supplierProducerList: SupplierProducer[];
  workflowList: Workflow[];
  supplierList: Organization[];
  workflowSuppliers: WorkflowSupplier[];
  page: number;
  pageSize: number;
  count: number;
  selectedSupplier: Organization | null;
  selectedWorkflow: Workflow | null;
  hoId: number;
  selectedProducerList: SupplierProducer[];
}
type WorkflowSupplierProducerDiscountProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class WorkflowSupplierProducerDiscountComponent extends React.PureComponent<
  WorkflowSupplierProducerDiscountProps,
  WorkflowSupplierProducerDiscountState
> {
  private translatorService!: ITranslatorService;
  private workflowService!: IWorkflowService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;
  private newWorkflowSupplierProducerDiscount = {
    id: 0,
    producerId: null,
    workflow: null,
    workflowSupplier: null,
    supplierProducer: null,
    discount: 0
  } as WorkflowSupplierProducerDiscount;

  state = {
    workflowSupplierProducerDiscountList: [],
    isLoading: false,
    supplierProducerList: [] as SupplierProducer[],
    isDialogOpen: false,
    newWorkflowSupplierProducerDiscount: this.newWorkflowSupplierProducerDiscount,
    newWorkflowSupplierProducerDiscountId: null,
    workflowList: [] as Workflow[],
    workflowSuppliers: [] as WorkflowSupplier[],
    page: 0,
    pageSize: 10,
    count: 1,
    selectedSupplier: null,
    selectedWorkflow: null,
    hoId: 0,
    supplierList: [] as Organization[],
    selectedProducerList: [] as SupplierProducer[]
  } as WorkflowSupplierProducerDiscountState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadWorkflowSupplierProducerDiscountList();
      }
    );
  }

  loadWorkflowSupplierProducerDiscountList = async () => {
    const hoId = this.props.appState.appUser?.organizationId;

    if (!hoId) {
      this.setState({
        isLoading: false
      });
      return;
    }

    const filters = {
      supplierIds: this.state.selectedSupplier ? [this.state.selectedSupplier.id] : [],
      workflowIds: this.state.selectedWorkflow ? [this.state.selectedWorkflow.id] : [],
      producerIds:
        this.state.selectedProducerList.length > 0
          ? this.state.selectedProducerList.map((item) => item.id)
          : [],
      page: this.state.page + 1,
      pageSize: this.state.pageSize,
      organizationId: hoId
    } as WorkflowSupplierProducerDiscountFilters;

    const [workflowSupplierProducerDiscountList, producerList, workflows, workflowSuppliers] =
      await Promise.all([
        this.workflowService.GetWorkflowSupplierProducerDiscounts(filters),
        this.workflowService.GetSupplierProducers(),
        this.workflowService.GetWorkflowsByOrgId(hoId),
        this.workflowService.GetWorkflowSuppliersByOrgId(hoId)
      ]);

    const suppliers = await this.organizationService.GetHOOrganizationsByTypes([
      OrganizationTypeCode.SUPPLIER
    ]);
    workflowSuppliers.forEach((item) => {
      const supplier = suppliers.find(
        (supplierItem) => !R.isNil(item.supplierId) && supplierItem.id === item.supplierId
      );
      item.supplier = R.isNil(supplier) ? null : supplier;
    });

    const workflowSupplierProducerDiscounts =
      workflowSupplierProducerDiscountList.workflowSupplierProducerDiscounts;
    workflowSupplierProducerDiscounts.forEach((item) => {
      if (item.workflowSupplier != null) {
        const supplier = suppliers.find(
          (supplierItem) =>
            !R.isNil(item.workflowSupplier?.supplierId) &&
            supplierItem.id === item.workflowSupplier.supplierId
        );

        item.workflowId = !R.isNil(item.workflowSupplier.workflowId)
          ? item.workflowSupplier.workflowId
          : 0;
        item.workflow = !R.isNil(item.workflowSupplier.workflow)
          ? item.workflowSupplier.workflow
          : null;
        item.supplierId = !R.isNil(supplier) ? supplier.id : 0;
        item.workflowSupplier.supplier = R.isNil(supplier) ? null : supplier;
      }
    });

    console.log('workflowSuppliers', workflowSuppliers);
    console.log('workflowSupplierProducerDiscounts', workflowSupplierProducerDiscounts);

    this.setState({
      workflowSupplierProducerDiscountList: workflowSupplierProducerDiscounts,
      page: workflowSupplierProducerDiscountList.page - 1,
      count: workflowSupplierProducerDiscountList.total,
      pageSize: this.state.pageSize,
      isLoading: false,
      newWorkflowSupplierProducerDiscount: { ...this.newWorkflowSupplierProducerDiscount },
      supplierProducerList: producerList,
      workflowList: workflows.filter((workflow) => workflow.isActive),
      workflowSuppliers: workflowSuppliers.filter((workflowSupplier) => workflowSupplier.isActive),
      supplierList: suppliers,
      hoId: hoId
    });
  };

  reloadWorkflowSuppliersProducerDiscounts = async (page: number, rowsPerPage: number) => {
    this.setState({ isLoading: true });

    const filters = {
      supplierIds: this.state.selectedSupplier ? [this.state.selectedSupplier.id] : [],
      workflowIds: this.state.selectedWorkflow ? [this.state.selectedWorkflow.id] : [],
      producerIds:
        this.state.selectedProducerList.length > 0
          ? this.state.selectedProducerList.map((item) => item.id)
          : [],
      page: page + 1,
      pageSize: rowsPerPage,
      organizationId: this.state.hoId
    } as WorkflowSupplierProducerDiscountFilters;

    const workflowSupplierProducerDiscountList =
      await this.workflowService.GetWorkflowSupplierProducerDiscounts(filters);
    const workflowSupplierProducerDiscounts =
      workflowSupplierProducerDiscountList.workflowSupplierProducerDiscounts;
    workflowSupplierProducerDiscounts.forEach((item) => {
      if (item.workflowSupplier != null) {
        const supplier = this.state.supplierList.find(
          (supplierItem) =>
            !R.isNil(item.workflowSupplier?.supplierId) &&
            supplierItem.id === item.workflowSupplier.supplierId
        );

        item.workflowId = !R.isNil(item.workflowSupplier.workflowId)
          ? item.workflowSupplier.workflowId
          : 0;
        item.workflow = !R.isNil(item.workflowSupplier.workflow)
          ? item.workflowSupplier.workflow
          : null;
        item.supplierId = !R.isNil(supplier) ? supplier.id : 0;
        item.workflowSupplier.supplier = R.isNil(supplier) ? null : supplier;
      }
    });

    this.setState({
      workflowSupplierProducerDiscountList: workflowSupplierProducerDiscounts,
      isLoading: false,
      page: workflowSupplierProducerDiscountList.page - 1,
      pageSize: rowsPerPage,
      count: workflowSupplierProducerDiscountList.total
    });
  };

  private handleDiscountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newWorkflowSupplierProducerDiscount: {
        ...this.state.newWorkflowSupplierProducerDiscount,
        discount: event.target.value === null ? 0 : parseFloat(event.target.value)
      }
    });
  };

  private handleDiscountTariffChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newWorkflowSupplierProducerDiscount: {
        ...this.state.newWorkflowSupplierProducerDiscount,
        discountTariff: event.target.value === null ? 0 : parseFloat(event.target.value)
      }
    });
  };

  private handleWorkflowChange = (newValue: Workflow | null) => {
    this.setState({
      newWorkflowSupplierProducerDiscount: {
        ...this.state.newWorkflowSupplierProducerDiscount,
        workflow: newValue,
        workflowId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleWorkflowSupplierChange = (newValue: WorkflowSupplier | null) => {
    this.setState({
      newWorkflowSupplierProducerDiscount: {
        ...this.state.newWorkflowSupplierProducerDiscount,
        workflowSupplier: newValue,
        workflowSupplierId: newValue !== null ? newValue.id : 0,
        supplier: newValue?.supplier || null,
        supplierId: newValue !== null ? newValue.supplierId : 0,
        discountTariff: newValue !== null ? newValue.discountTariff : 0
      }
    });
  };

  private handleSupplierProducerChange = (newValue: SupplierProducer | null) => {
    this.setState({
      newWorkflowSupplierProducerDiscount: {
        ...this.state.newWorkflowSupplierProducerDiscount,
        producerId: newValue !== null ? newValue.id : 0,
        supplierProducer: newValue
      }
    });
  };

  public saveWorkflowSupplierProducerDiscount = async () => {
    try {
      const response = await this.workflowService.AddWorkflowSupplierProducerDiscount(
        this.state.newWorkflowSupplierProducerDiscount
      );
      if (!response.success) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(response.message, response.message),
          {
            variant: 'error'
          }
        );
        return;
      }
      await this.loadWorkflowSupplierProducerDiscountList();
      this.closeDialog();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator
        decimalScale={2}
        isNumericString
        suffix=" %"
      />
    );
  };

  getWorkflowSuppliersOptions(): WorkflowSupplier[] {
    const filteredWorkflowSuppliers = this.state.workflowSuppliers.filter(
      (workflowSupplier) =>
        this.state.newWorkflowSupplierProducerDiscount.workflowId &&
        workflowSupplier.workflowId === this.state.newWorkflowSupplierProducerDiscount.workflowId
    );

    return (
      filteredWorkflowSuppliers.sort((a, b) => {
        const nameA = a.supplier?.name ?? '';
        const nameB = b.supplier?.name ?? '';
        return nameA.localeCompare(nameB);
      }) || []
    );
  }

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveWorkflowSupplierProducerDiscount} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="wokflow"
            fullWidth
            options={this.state.workflowList}
            value={this.state.newWorkflowSupplierProducerDiscount.workflow}
            onChange={(e: any, newValue: Workflow | null) => this.handleWorkflowChange(newValue)}
            getOptionLabel={(option: Workflow) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="workflow"
                value={this.state.newWorkflowSupplierProducerDiscount.workflow?.displayName || ''}
                label={this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIER_PRODUCER_WORKFLOW',
                  'Flux de lucru'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="suppliers"
            fullWidth
            options={this.getWorkflowSuppliersOptions()}
            value={this.state.newWorkflowSupplierProducerDiscount.workflowSupplier}
            onChange={(e: any, newValue: WorkflowSupplier | null) =>
              this.handleWorkflowSupplierChange(newValue)
            }
            getOptionLabel={(option: WorkflowSupplier) => option.supplier?.name || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="suppliers"
                value={
                  this.state.newWorkflowSupplierProducerDiscount.workflowSupplier?.supplier?.name ||
                  ''
                }
                label={this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_LABEL',
                  'Furnizor'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="discountTariff"
            id="discountTariff"
            value={this.state.newWorkflowSupplierProducerDiscount.discountTariff}
            onChange={this.handleDiscountTariffChange}
            label={this.translatorService.Tranlate(
              'WORKFLOW_GENERAL_DISCOUNT_TARIFF',
              'Discount Furnizor (%)'
            )}
            validators={['required', 'minNumber:0', 'maxNumber:100']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              ),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              )
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="supplierProducer"
            fullWidth
            options={this.state.supplierProducerList}
            value={this.state.newWorkflowSupplierProducerDiscount.supplierProducer}
            onChange={(e: any, newValue: SupplierProducer | null) =>
              this.handleSupplierProducerChange(newValue)
            }
            getOptionLabel={(option: SupplierProducer) => option.producer || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="supplierProducer"
                value={
                  this.state.newWorkflowSupplierProducerDiscount.supplierProducer?.producer || ''
                }
                label={this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIER_PRODUCER_PRODUCER',
                  'Producator'
                )}
                fullWidth
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="discount"
            id="discount"
            value={this.state.newWorkflowSupplierProducerDiscount.discount}
            onChange={this.handleDiscountChange}
            label={this.translatorService.Tranlate(
              'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT',
              'Discount Producator (%)'
            )}
            validators={['required', 'minNumber:0', 'maxNumber:100']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              ),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              )
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'workflowSupplier.workflow',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIER_PRODUCER_WORKFLOW',
          'Flux de lucru'
        ),
        options: {
          sort: true,
          customSort: (a: Workflow, b: Workflow) => {
            return a.displayName!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: Workflow) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'workflowSupplier.supplier.name',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIERS_TAB_SUPPLIER_HEADER', 'Furnizor')
      },
      {
        name: 'workflowSupplier.discountTariff',
        label: this.translatorService.Tranlate(
          'WORKFLOW_GENERAL_DISCOUNT_TARIFF',
          'Discount Furnizor (%)'
        )
      },
      {
        name: 'supplierProducer',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIER_PRODUCER_PRODUCER', 'Producator'),
        options: {
          sort: true,
          customSort: (a: SupplierProducer, b: SupplierProducer) => {
            return a.producer!.localeCompare(b.producer!);
          },
          customBodyRender: (value: SupplierProducer) => {
            return value ? value.producer : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'discount',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT',
          'Discount Producator (%)'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) =>
                    this.newWorkflowSupplierProducerDiscountPopup(tableMeta.rowData[0])
                  }
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteWorkflowSupplierProducerDiscount(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteWorkflowSupplierProducerDiscount = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.workflowService.RemoveWorkflowSupplierProducerDiscount(id);
      await this.loadWorkflowSupplierProducerDiscountList();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newWorkflowSupplierProducerDiscountPopup = async (supplierProducerId: number | null) => {
    let newWorkflowSupplierProducerDiscount: WorkflowSupplierProducerDiscount;
    if (supplierProducerId == null) {
      newWorkflowSupplierProducerDiscount = {
        ...this.state.newWorkflowSupplierProducerDiscount
      } as WorkflowSupplierProducerDiscount;
    } else {
      newWorkflowSupplierProducerDiscount = this.state.workflowSupplierProducerDiscountList.find(
        (item) => item.id === supplierProducerId
      )!;
    }
    newWorkflowSupplierProducerDiscount.discountTariff =
      newWorkflowSupplierProducerDiscount.workflowSupplier?.discountTariff || 0;
    this.setState({
      isDialogOpen: true,
      newWorkflowSupplierProducerDiscount: newWorkflowSupplierProducerDiscount,
      newWorkflowSupplierProducerDiscountId: supplierProducerId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newWorkflowSupplierProducerDiscount: this.newWorkflowSupplierProducerDiscount
    });
  };

  handleWorkflowsChange = (newValue: Workflow | null) => {
    this.setState(
      {
        selectedWorkflow: newValue,
        isLoading: true
      },
      async () =>
        await this.reloadWorkflowSuppliersProducerDiscounts(this.state.page, this.state.pageSize)
    );
  };

  handleSuppliersChange = (newValue: Organization | null) => {
    this.setState(
      {
        selectedSupplier: newValue,
        isLoading: true
      },
      async () =>
        await this.reloadWorkflowSuppliersProducerDiscounts(this.state.page, this.state.pageSize)
    );
  };

  handleSelectedProducers = (newValue: any[]) => {
    this.setState(
      {
        selectedProducerList: newValue,
        isLoading: true
      },
      async () =>
        await this.reloadWorkflowSuppliersProducerDiscounts(this.state.page, this.state.pageSize)
    );
  };

  getWorkflowSuppliersFilterOptions(): Organization[] {
    const workflowId = this.state.selectedWorkflow?.id;
    if (!workflowId) return [];

    const activeSupplierIds = this.state.workflowSuppliers
      .filter((ws) => ws.workflowId === workflowId && ws.isActive)
      .map((ws) => ws.supplierId);
    const filteredSuppliers = this.state.supplierList.filter((supplier) =>
      activeSupplierIds.includes(supplier.id)
    );

    return filteredSuppliers.sort((a, b) => {
      const nameA = a.name ?? '';
      const nameB = b.name ?? '';
      return nameA.localeCompare(nameB);
    });
  }

  renderFilters = () => {
    return (
      <div className="mt-3">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box mb={2}>
              <Autocomplete
                id="workflow"
                size="small"
                options={this.state.workflowList}
                value={this.state.selectedWorkflow}
                onChange={(e: any, newValue: any | null) => this.handleWorkflowsChange(newValue)}
                getOptionLabel={(option: any) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="workflow"
                    value={this.state.selectedWorkflow}
                    label={this.translatorService.Tranlate(
                      'WORKFLOW_SUPPLIER_PRODUCER_WORKFLOW',
                      'Flux de lucru'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>

            <Box mb={2}>
              <Autocomplete
                id="producers"
                size="small"
                multiple
                options={this.state.supplierProducerList}
                value={this.state.selectedProducerList}
                onChange={(e: any, newValue: any | null) => this.handleSelectedProducers(newValue)}
                getOptionLabel={(option: SupplierProducer) => option.producer || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="producers"
                    value={this.state.selectedProducerList}
                    label={this.translatorService.Tranlate(
                      'WORKFLOW_SUPPLIER_PRODUCER_PRODUCER',
                      'Producator'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box mb={2}>
              <Autocomplete
                id="suppliers"
                size="small"
                options={this.getWorkflowSuppliersFilterOptions()}
                value={this.state.selectedSupplier}
                onChange={(e: any, newValue: any | null) => this.handleSuppliersChange(newValue)}
                getOptionLabel={(option: any) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="suppliers"
                    value={this.state.selectedSupplier}
                    label={this.translatorService.Tranlate(
                      'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_HEADER',
                      'Furnizor'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.workflowService = (this.context as AppContext).workflowService;
    this.organizationService = (this.context as AppContext).organizationService;

    const options = {
      filter: false,
      search: false,
      sort: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      elevation: 0,
      serverSide: true,
      count: this.state.count,
      rowsPerPage: this.state.pageSize,
      page: this.state.page,
      onTableChange: async (action: any, tableState: any) => {
        switch (action) {
          case 'changePage':
            await this.reloadWorkflowSuppliersProducerDiscounts(
              tableState.page,
              tableState.rowsPerPage
            );
            break;
          case 'changeRowsPerPage':
            await this.reloadWorkflowSuppliersProducerDiscounts(
              tableState.page,
              tableState.rowsPerPage
            );
            break;
          case 'sort':
            break;
          default:
        }
      },
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newWorkflowSupplierProducerDiscountPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
        <Card>
          <div
            style={{
              backgroundColor: 'var(--primary)',
              fontWeight: 500,
              borderBottom: '4px solid var(--primary-extra-light)'
            }}
            className="card-header text-white text-center"
          >
            <span className="mb-0 py-2">
              {this.translatorService.Tranlate(
                'MENU_SETTINGS_TAB_PRODUCERS_DISCOUNTS',
                'Discounturi producatori furnizori'
              )}
            </span>
          </div>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? <div className="ml-3 mr-3">{this.renderFilters()}</div> : null}

          <Box m={1} p={1}>
            <div className="d-flex flex-row text-center flex-wrap justify-content-center">
              <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
            </div>
            {!this.state.isLoading ? (
              <MUIDataTable
                title={''}
                data={this.state.workflowSupplierProducerDiscountList}
                columns={this.getColumns()}
                options={options}
              />
            ) : null}
          </Box>
        </Card>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {!this.state.newWorkflowSupplierProducerDiscountId
                      ? this.translatorService.Tranlate(
                          'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT_ADD_MODAL_TITLE',
                          'Adauga Discount Producator'
                        )
                      : this.translatorService.Tranlate(
                          'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT_EDIT_MODAL_TITLE',
                          'Editeaza Discount Producator'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(WorkflowSupplierProducerDiscountComponent as any));
